import type { ListBuilderConfiguration } from '../../types';
import { clientEmbeddedAbandonedCartsList } from './lists/client-embedded-abandoned-carts';
import { clientEmbeddedCartsList } from './lists/client-embedded-carts';
import { clientEmbeddedOrdersList } from './lists/client-embedded-orders';
import { clientEmbeddedOrdersAllList } from './lists/client-embedded-orders-all';
import { clientEmbeddedRequiresApprovalOrdersList } from './lists/client-embedded-requires-approval-orders';
import { clientEmbeddedRequiresAttentionList } from './lists/client-embedded-requires-attention';
import { clientEmbeddedWebCartsList } from './lists/client-embedded-web-carts';

/**
 * Order client embedded list configuration
 * Orders embedded in client view - no client info columns
 */
export const ORDER_CLIENT_EMBEDDED_CONFIG: ListBuilderConfiguration = {
	objectType: 'order',
	lists: [
		clientEmbeddedOrdersList,
		clientEmbeddedRequiresApprovalOrdersList,
		clientEmbeddedRequiresAttentionList,
		clientEmbeddedCartsList,
		clientEmbeddedWebCartsList,
		clientEmbeddedAbandonedCartsList,
		clientEmbeddedOrdersAllList,
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [20, 50, 100],
	},
	showResetButton: true,
	filters: {
		activeFilters: [
			'childAccounts',
			'orderKeywords',
			'orderStatus',
			'orderOrigin',
			'orderSalesRep',
			'orderCompany',
			'orderDateRange',
		],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/orders/:id',
			objectLabel: 'Order',
			objectTable: 'order',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'externalId', fieldLabel: 'External ID' },
				{ fieldName: 'externalId2', fieldLabel: 'External ID 2' },
				{ fieldName: 'date', fieldLabel: 'Date' },
				{ fieldName: 'clientName', fieldLabel: 'Client Name' },
				{ fieldName: 'clientAddress1', fieldLabel: 'Client Address 1' },
				{ fieldName: 'clientAddress2', fieldLabel: 'Client Address 2' },
				{ fieldName: 'clientCity', fieldLabel: 'Client City' },
				{ fieldName: 'clientState', fieldLabel: 'Client State' },
				{ fieldName: 'clientZip', fieldLabel: 'Client Zip' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'numberOfLines', fieldLabel: 'Number of Lines' },
				{ fieldName: 'total', fieldLabel: 'Total' },
				{ fieldName: 'customerPO', fieldLabel: 'Customer PO' },
			],
		},
		{
			baseUrl: '/clients/:id',
			objectLabel: 'Client',
			objectTable: 'client',
			selectedFields: [
				{ fieldName: '_id', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
			],
		},
	],
	tableSorts: [
		{
			id: 'date-desc',
			name: 'Date (Newest First)',
			fields: [{ direction: 'DESC', fieldName: 'date', objectTable: 'order' }],
			description: 'Sort orders by date, newest first',
		},
		{
			id: 'date-asc',
			name: 'Date (Oldest First)',
			fields: [{ direction: 'ASC', fieldName: 'date', objectTable: 'order' }],
			description: 'Sort orders by date, oldest first',
		},
		{
			id: 'external-id-asc',
			name: 'Order # (Low to High)',
			fields: [{ direction: 'ASC', fieldName: 'id', objectTable: 'order' }],
			description: 'Sort orders by order ID, ascending',
		},
		{
			id: 'external-id-desc',
			name: 'Order # (High to Low)',
			fields: [{ direction: 'DESC', fieldName: 'id', objectTable: 'order' }],
			description: 'Sort orders by order ID, descending',
		},
		{
			id: 'total-desc',
			name: 'Total (Highest First)',
			fields: [{ direction: 'DESC', fieldName: 'total', objectTable: 'order' }],
			description: 'Sort orders by total amount, highest first',
		},
		{
			id: 'status',
			name: 'Status',
			fields: [{ direction: 'ASC', fieldName: 'status', objectTable: 'order' }],
			description: 'Sort orders by status',
		},
	],
};
